/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Choose_YearlyInputs */

const en_pricing_choose_yearly = /** @type {(inputs: Pricing_Choose_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose yearly`)
};

const es_pricing_choose_yearly = /** @type {(inputs: Pricing_Choose_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir anual`)
};

/**
* | output |
* | --- |
* | "Choose yearly" |
*
* @param {Pricing_Choose_YearlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_choose_yearly = /** @type {((inputs?: Pricing_Choose_YearlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Choose_YearlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_choose_yearly(inputs)
	return en_pricing_choose_yearly(inputs)
});